import React, { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import Avatar from 'components/common/Avatar';
// import CardDropdown from 'components/common/CardDropdown';
// import FalconCardFooterLink from 'components/common/FalconCardFooterLink';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
// import IconItem from 'components/common/icon/IconItem';
import SubtleBadge from 'components/common/SubtleBadge';
// import { recentLeadsTableData } from 'data/dashboard/crm';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import PropTypes from 'prop-types';
import paths from 'routes/paths';
import FalconCloseButton from 'components/common/FalconCloseButton';

const RecentLeads = ({ data, tableDetails, setTableDetails }) => {
  const [profileViewData, setProfileViewData] = useState(undefined);
  const [profileView, setProfileView] = useState(false);

  let tableData =
    tableDetails?.title === 'Total Nurse'
      ? data?.array?.map(i => i?.original)
      : tableDetails?.title === 'Missing Certifications'
      ? data?.nurseCertificationsEmptyID
      : tableDetails?.title === 'Missing Documents'
      ? data?.nurseDocumentsEmptyID
      : tableDetails?.title === 'Documents and Certifications'
      ? data?.nurseDocumentsAndCertificationsID
      : [];

  const columns = [
    {
      accessorKey: 'name',
      header: 'Name',
      meta: {
        headerProps: {
          className: 'py-0 ps-3 text-900'
        },
        cellProps: {
          className: 'ps-3'
        }
      },
      cell: ({ row: { original } }) => {
        const { name, profileImage } = original;
        return (
          <div
            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
            onClick={() => {
              setProfileViewData(original);
              setProfileView(!profileView);
            }}
          >
            {profileImage ? (
              <Avatar size="xl" src={profileImage} className="me-2" />
            ) : (
              <Avatar size="xl" name={name} className="me-2" />
            )}
            <h6 className="mb-0 ps-2">{name}</h6>
          </div>
        );
      }
    },
    {
      accessorKey: 'email',
      header: 'Email and Phone',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { email } = original;
        return (
          <a href={`mailto:${email}`} className="mb-0">
            {email}
          </a>
        );
      }
    },
    {
      accessorKey: 'status',
      header: 'Certifications & Documents',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { certificationsLength, documentsLength } = original;
        return (
          <div className="flex">
            <SubtleBadge pill bg="primary" className="me-2">
              {certificationsLength}
            </SubtleBadge>
            <SubtleBadge pill bg="primary" className="me-2">
              {documentsLength}
            </SubtleBadge>
          </div>
        );
      }
    }
    // {
    //   accessorKey: 'Action',
    //   header: 'Action',
    //   meta: {
    //     headerProps: {
    //       className: 'text-end text-900'
    //     },
    //     cellProps: {
    //       className: 'text-end'
    //     }
    //   },
    //   enableSorting: false,
    //   cell: () => (
    //     <div>
    //       <div className="hover-actions bg-100">
    //         <IconItem
    //           tag="button"
    //           icon={['far', 'edit']}
    //           size="sm"
    //           className="btn rounded-3 me-2 fs-11"
    //         />
    //         <IconItem
    //           tag="button"
    //           icon={['far', 'comment']}
    //           size="sm"
    //           className="btn rounded-3 me-2 fs-11"
    //         />
    //       </div>
    //       <CardDropdown btnRevealClass="btn-reveal-sm" drop="start" />
    //     </div>
    //   )
    // }
  ];

  const columnsCertification = [
    {
      accessorKey: 'certificationType',
      header: 'Type',
      meta: {
        headerProps: {
          className: 'py-0 ps-0 text-900'
        },
        cellProps: {
          className: 'ps-0'
        }
      },
      cell: ({ row: { original } }) => {
        const { certificationType } = original;
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h6 className="mb-0 ps-2">{certificationType}</h6>
          </div>
        );
      }
    },
    {
      accessorKey: 'certificationDate',
      header: 'Valid UnTill',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { valid } = original;
        return <h6 className="mb-0 ps-2">{valid}</h6>;
      }
    },
    {
      accessorKey: 'expirationStatus',
      header: 'Valid',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { expirationStatus } = original;
        return (
          <SubtleBadge
            pill
            bg={expirationStatus ? 'danger' : 'success'}
            className="me-2"
          >
            {expirationStatus ? 'Expired' : 'Valid'}
          </SubtleBadge>
        );
      }
    }
    // {
    //   accessorKey: 'Action',
    //   header: 'Action',
    //   meta: {
    //     headerProps: {
    //       className: 'text-end text-900'
    //     },
    //     cellProps: {
    //       className: 'text-end'
    //     }
    //   },
    //   enableSorting: false,
    //   cell: () => (
    //     <div>
    //       <div className="hover-actions bg-100">
    //         <IconItem
    //           tag="button"
    //           icon={['far', 'edit']}
    //           size="sm"
    //           className="btn rounded-3 me-2 fs-11"
    //         />
    //         <IconItem
    //           tag="button"
    //           icon={['far', 'comment']}
    //           size="sm"
    //           className="btn rounded-3 me-2 fs-11"
    //         />
    //       </div>
    //       <CardDropdown btnRevealClass="btn-reveal-sm" drop="start" />
    //     </div>
    //   )
    // }
  ];

  const columnsDocuments = [
    {
      accessorKey: 'documentName',
      header: 'Name',
      meta: {
        headerProps: {
          className: 'py-0 ps-0 text-900'
        },
        cellProps: {
          className: 'ps-0'
        }
      },
      cell: ({ row: { original } }) => {
        const { documentName } = original;
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h6 className="mb-0 ps-2">{documentName}</h6>
          </div>
        );
      }
    },
    {
      accessorKey: 'certificationDate',
      header: 'Valid UnTill',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { valid } = original;
        return <h6 className="mb-0 ps-2">{valid}</h6>;
      }
    },
    {
      accessorKey: 'expirationStatus',
      header: 'Valid',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { expirationStatus } = original;
        return (
          <SubtleBadge
            pill
            bg={expirationStatus ? 'danger' : 'success'}
            className="me-2"
          >
            {expirationStatus ? 'Expired' : 'Valid'}
          </SubtleBadge>
        );
      }
    },
    {
      accessorKey: 'verified',
      header: 'Verified',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { verified } = original;
        return (
          <SubtleBadge
            pill
            bg={verified ? 'success' : 'danger'}
            className="me-2"
          >
            {verified ? 'Yes' : 'No'}
          </SubtleBadge>
        );
      }
    }
    // {
    //   accessorKey: 'Action',
    //   header: 'Action',
    //   meta: {
    //     headerProps: {
    //       className: 'text-end text-900'
    //     },
    //     cellProps: {
    //       className: 'text-end'
    //     }
    //   },
    //   enableSorting: false,
    //   cell: () => (
    //     <div>
    //       <div className="hover-actions bg-100">
    //         <IconItem
    //           tag="button"
    //           icon={['far', 'edit']}
    //           size="sm"
    //           className="btn rounded-3 me-2 fs-11"
    //         />
    //         <IconItem
    //           tag="button"
    //           icon={['far', 'comment']}
    //           size="sm"
    //           className="btn rounded-3 me-2 fs-11"
    //         />
    //       </div>
    //       <CardDropdown btnRevealClass="btn-reveal-sm" drop="start" />
    //     </div>
    //   )
    // }
  ];

  const table = useAdvanceTable({
    data: tableData,
    columns,
    // selection: true,
    sortable: true,
    pagination: true,
    perPage: 10,
    selectionColumnWidth: 28,
    selectionHeaderClassname: 'py-0'
  });

  const tableProfileCertification = useAdvanceTable({
    data:
      profileViewData?.certificationsLength !== 0
        ? profileViewData?.certifications?.array
        : [],
    columns: columnsCertification,
    selection: true,
    sortable: true,
    pagination: true,
    perPage: 10,
    selectionColumnWidth: 28,
    selectionHeaderClassname: 'py-0'
  });

  const tableProfileDocuments = useAdvanceTable({
    data:
      profileViewData?.documentsLength !== 0
        ? profileViewData?.documents?.array
        : [],
    columns: columnsDocuments,
    selection: true,
    sortable: true,
    pagination: true,
    perPage: 10,
    selectionColumnWidth: 28,
    selectionHeaderClassname: 'py-0'
  });

  const handleClick = () => {
    setTableDetails({
      title: '',
      view: false
    });
  };

  return (
    <>
      {profileView ? (
        <>
          <Card className="py-3 px-4 mb-3">
            <Flex justifyContent={'between'} alignItems={'center'}>
              <Link
                to={paths.nursd_profile(profileViewData?.id, 'profile')}
                target="_blank"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer'
                }}
              >
                {profileViewData?.profileImage ? (
                  <Avatar
                    size="2xl"
                    src={profileViewData?.profileImage}
                    className="me-2"
                  />
                ) : (
                  <Avatar
                    size="2xl"
                    name={profileViewData?.name}
                    className="me-2"
                  />
                )}
                <>
                  <h5 className="mb-0 ps-2">{profileViewData?.name}</h5>
                  <h6 className="mb-0 ps-2">
                    ({profileViewData?.licenseType})
                  </h6>
                </>
              </Link>
              <FalconCloseButton onClick={() => handleClick()} />
            </Flex>
          </Card>
          <Row>
            <Col md="5">
              <AdvanceTableProvider {...tableProfileCertification}>
                <Card>
                  <FalconCardHeader
                    title={'Certification List'}
                    titleTag="h6"
                    className="py-3"
                    // endEl={<CardDropdown />}
                  />
                  <Card.Body className="p-0">
                    <AdvanceTable
                      headerClassName="bg-200 text-nowrap align-middle"
                      rowClassName="align-middle white-space-nowrap hover-actions-trigger btn-reveal-trigger hover-bg-100"
                      tableProps={{
                        className: 'fs-10 mb-0 overflow-hidden'
                      }}
                    />
                  </Card.Body>
                  <Card.Footer className="px-2 py-3">
                    {/* <FalconCardFooterLink title="Show full list" size="sm" /> */}
                    <AdvanceTableFooter
                      rowInfo
                      navButtons
                      rowsPerPageSelection
                    />
                  </Card.Footer>
                </Card>
              </AdvanceTableProvider>
            </Col>
            <Col md="7">
              <AdvanceTableProvider {...tableProfileDocuments}>
                <Card>
                  <FalconCardHeader
                    title={'Documents List'}
                    titleTag="h6"
                    className="py-3"
                    // endEl={<CardDropdown />}
                  />
                  <Card.Body className="p-0">
                    <AdvanceTable
                      headerClassName="bg-200 text-nowrap align-middle"
                      rowClassName="align-middle white-space-nowrap hover-actions-trigger btn-reveal-trigger hover-bg-100"
                      tableProps={{
                        className: 'fs-10 mb-0 overflow-hidden'
                      }}
                    />
                  </Card.Body>
                  <Card.Footer className="px-2 py-3">
                    {/* <FalconCardFooterLink title="Show full list" size="sm" /> */}
                    <AdvanceTableFooter
                      rowInfo
                      navButtons
                      rowsPerPageSelection
                    />
                  </Card.Footer>
                </Card>
              </AdvanceTableProvider>
            </Col>
          </Row>
        </>
      ) : (
        <AdvanceTableProvider {...table}>
          <Card className="mb-3">
            <FalconCardHeader
              title={tableDetails?.title}
              titleTag="h6"
              className="py-3"
              // endEl={<CardDropdown />}
            />
            <Card.Body className="p-0">
              <AdvanceTable
                headerClassName="bg-200 text-nowrap align-middle"
                rowClassName="align-middle white-space-nowrap hover-actions-trigger btn-reveal-trigger hover-bg-100"
                tableProps={{
                  className: 'fs-10 mb-0 overflow-hidden'
                }}
              />
            </Card.Body>
            <Card.Footer className="px-2 py-3">
              {/* <FalconCardFooterLink title="Show full list" size="sm" /> */}
              <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection />
            </Card.Footer>
          </Card>
        </AdvanceTableProvider>
      )}
    </>
  );
};

RecentLeads.propTypes = {
  data: PropTypes.any,
  tableDetails: PropTypes.any,
  setTableDetails: PropTypes.any
};

export default RecentLeads;
